import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import Slider from 'react-slick';

import {Close} from '../close/Close';
import {Prev, Next} from '../arrow/Arrow';

import 'slick-carousel/slick/slick.css';
import './gallery.css';

export class GalleryComponent extends Component {

  state = {
    ready: false,
  };

  componentDidMount() {
    this.delayShow = setTimeout(() => {
      this.setState({ready: true});
    }, 700);
  }

  componentWillUnmount() {
    clearTimeout(this.delayShow )
  }

  render() {
    const {photos, hasPhotos, hasSlider} = this.props;
    const {ready} = this.state;

    const settings = hasSlider ? {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <Next/>,
      prevArrow: <Prev/>,
    } : {
      arrows: false,
    };

    return (
      <div className="page gallery">
        {hasPhotos && ready? (
          <Slider classname="slider" {...settings}>
            {
              photos.map(({alt_sizes}, index) => {
                const {url} = alt_sizes[0];
                return (
                  <div key={index} className="slick-image" style={{backgroundImage: `url('${url}')`}} />
                );
              })
            }
          </Slider>
        ) : null}
        <Close target="/" />
      </div>
    );
  }
};

GalleryComponent.displayName = 'Gallery';

GalleryComponent.propTypes = {
  photos: PropTypes.array.isRequired,
  caption: PropTypes.string,
  post_url: PropTypes.string,
  hasPhotos: PropTypes.bool,
  hasSlider: PropTypes.bool,
};

const mapStateToProps = ({images}, {params: {image:imageId}}) => {
  const {caption, photos, post_url} = images.getIn(['images', imageId], {photos: []});

  return {
    caption,
    photos,
    post_url,
    hasPhotos: photos.length > 0,
    hasSlider: photos.length > 1,
  };
};

export const Gallery = connect(mapStateToProps, {})(GalleryComponent);



// WEBPACK FOOTER //
// ./src/components/gallery/Gallery.js